import { render, staticRenderFns } from "./ScaleTemplateViewer.vue?vue&type=template&id=13e1d754&scoped=true"
import script from "./ScaleTemplateViewer.vue?vue&type=script&lang=ts"
export * from "./ScaleTemplateViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e1d754",
  null
  
)

export default component.exports